/**
 *
 * @param {string} hex rgb color in hex
 * @returns {[red, green, blue]} array of RGB
 * @description convert rgb in hex format to rgb array
 */
const fullHex = (hex) => {
  let r = hex.slice(1, 2);
  let g = hex.slice(2, 3);
  let b = hex.slice(3, 4);

  r = parseInt(r + r, 16);
  g = parseInt(g + g, 16);
  b = parseInt(b + b, 16);

  return [r, g, b];
};
export default fullHex;
